export const paymentMakeInternationalPymt = `<p>An International payment lets you send money in a foreign currency to a beneficiary abroad, or to a UK beneficiary from a currency account or Sterling (GBP) overseas.</p>
<p>You'll need the beneficiary's full account details to successfully send a payment. The following information is guidance on best practise for International Payments and is summarised with mandatory fields to be completed.</p>
<p>Depending on the country you might also need to give extra information, such as the reason for the payment. It is your responsibility to make sure the information that you provide on an international payment is correct. Countries may change their requirements and you should always check country specific requirements with your customer before submitting the payment.</p>
<p>To assist with this you can refer to table in <strong><a href='javascript:void(0)' data-link='appendix3'>Appendix 3</a></strong> for payment details required based on destination country of beneficiary bank.</p>
<p>The payment must be approved and have an exchange rate booked before the daily cut-off time for it to be processed. The beneficiary’s bank should pay the beneficiary the same day but this can sometimes take longer based on the currencies involved in the transaction and the country of the beneficiary.&nbsp;</p>
<p>Cut-off times for International payments vary – check the cut-off times in <strong> <a href='javascript:void(0)' data-link='appendix2'>Appendix 2</a> </strong>for your currency.</p>
<p>If an International payment is submitted as a future dated payment then its execution time on the due date is 06:30. Payments can be edited or cancelled ahead of execution.</p>
<p><strong>Navigation</strong>: Payments / Create Payments / Create International Payment</p>
<p>Select the debit account you wish to create a payment from, using the Search or Advanced Search to provide a list of accounts you are entitled to use for making payment.</p>
<p>Under the Type dropdown, you can filter and select a real or virtual account.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/1.png' /></p>
<p>Debit Account details will be pre-populated and the option available to enter a Debit Account reference which will only show on your records.&nbsp;</p>
<p><strong>Beneficiary details</strong></p>
<p>Enter the beneficiary's name and account details in the boxes provided. This can be done as free text if the User has the entitlement set for ‘Freeform International payment beneficiary’ set against their Role Profile (Refer to Section <a href='javascript:void(0)' data-link='setupActivityRoleProfileUser'>'Set-up activity for role profiles and users'</a> for Role Profile information)&nbsp;</p>
<p>Alternatively, the user can search for saved beneficiaries by using the search button on the right hand side. <em>(To create a new Beneficiary refer to section <a href='javascript:void(0)' data-link='manageBeneficiaries'>'Manage Beneficiaries'</a>).</em> Search can be done on Sort Code, Account Number, Beneficiary Name, Preferred name or Bank ID.</p>
<p>Note that "<span style='color:red'>*</span>" denotes fields which are mandatory.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/7.png' /></p>
<p>The table shows you the field lengths and permitted character set for the beneficiary name and address fields.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/8.png' /></p>
<p>Where an <strong>IBAN</strong> is available to support the payment this should be used by selecting IBAN from the Beneficiary account type drop down. The following fields must be populated to support the successful processing of the payment (screen shots further down in the section).&nbsp;</p>
<ul>
<li>
Beneficiary Details
<ul class='list-style-circle'>
  <li>Beneficiary Name</li>
  <li>Beneficiary Account Type – Select IBAN</li>
  <li>Beneficiary Account Number – Add IBAN</li>
  <li>Town/City – Input the town or city of the beneficiary</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Beneficiary Bank Details
<ul class='list-style-circle'>
  <li>Beneficiary Bank SWIFT BIC - 11 character Branch BIC is preferable if known, if not use 8 character Head Office BIC</li>
  <li>Beneficiary Bank Name</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Payment Details
<ul class='list-style-circle'>
  <li>Execution date is pre-populated but can be changed for a future value dated payment</li>
  <li>Credit or Debit amount must be populated</li>
  <li>Charges will default to Shared but can be amended to Ours or Beneficiary</li>
  <li>Payment purpose code(PPC) is a four-character alphanumeric code which can be added to a payment instruction.  You can look up the correct code by hovering over the info pop up symbol</li>
</ul>
</li>
<li>
Intermediary Bank
<ul class='list-style-circle'>
  <li>This section is optional.</li>
  <li>You have an option to nominate your preferred intermediary bank. Sometimes we will use a different intermediary that we have a relationship with, to ensure the payment reaches the beneficiary. Please contact the Onboarding & Servicing Team if you want more information.</li>
  <li>If it is not completed then LLOYDS BANK use their own network of approved correspondent banks.</li>
  <li>If it is used then SWIFT Code is mandatory which then pre-populates all other fields.</li>
</ul>
</li>
<li>
Beneficiary Reference
<ul class='list-style-circle'>
  <li>You have the option to provide Beneficiary reference information that will be included within the outgoing payment message. For International payments, 4 beneficiary references lines - 3 lines with a maximum of 34 characters and the 4th with a maximum of 35 characters - may be provided. If you supply any beneficiary reference information, please populate Beneficiary reference line 1 first, followed by Beneficiary reference line 2 etc.</li>
</ul>
</li>
<li>
Ultimate Debtor(optional)
<ul class='list-style-circle'>
<li>The section for Ultimate debtor is optional but should be used if the party making the payment is not the debit account owner – i.e. for payments on behalf of another party (POBO).</li>
<li>For information about the Ultimate debtor (POBO) section, please click <a href='javascript:void(0)' data-link='ultimateDebator'>here</a>.</li>
</ul>
</li>
</ul>
<p>There are countries where a National Clearing Code (NCC) is mandatory or provide a better chance of their payment arriving successfully with its inclusion (e.g. United States (ABA), Canada, New Zealand, Australia (BSB Code), India (IFSC) all require a NCC to be supplied).&nbsp;</p>
<p>In this scenario, Select <strong>BBAN</strong> from the Beneficiary account type drop down. The following fields must be populated to support the successful processing of the payment (screen shots further down in the section):&nbsp;</p>
<ul>
<li>
Beneficiary Details
<ul class='list-style-circle'>
  <li>Beneficiary Name</li>
  <li>Beneficiary Account Type – Select BBAN</li>
  <li>Beneficiary Account Number – Provide the account number in the format required by the chosen Beneficiary Bank Code Type.</li>
  <li>Town/City – Input the town or city of the beneficiary</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Beneficiary Bank Details - <strong>For a UK Beneficiary</strong>
<ul class='list-style-circle'>
  <li>Beneficiary Bank Code Type - Select GBDSC</li>
  <li>Beneficiary Bank Code - Enter the UK Sort Code (ONLY)</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Beneficiary Bank Details - <strong>For a Non-UK Beneficiary</strong>
<ul class='list-style-circle'>
  <li>Beneficiary Bank Code Type - Select relevant option for Country (e.g.USABA)</li>
  <li>Beneficiary Bank Code – Enter relevant NCC for Country</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Payment Details
<ul class='list-style-circle'>
  <li>Execution date is pre-populated but can be changed for a future value dated payment</li>
  <li>Credit or Debit amount must be populated</li>
  <li>Charges will default to Shared but can be amended to Ours or Beneficiary</li>
  <li>Payment purpose code(PPC) is a four-character alphanumeric code which can be added to a payment instruction.  You can look up the correct code by hovering over the info pop up symbol</li>
</ul>
</li>
<li>
Intermediary Bank
<ul class='list-style-circle'>
  <li>This section is optional. You can select your own intermediary bank if you have a preference.&nbsp;</li>
  <li>If it is not completed then LLOYDS BANK use their own network of approved correspondent banks</li>
  <li>If it is used then SWIFT Code is mandatory which then pre-populates all other fields</li>
</ul>
</li>
<li>
Beneficiary Reference
<ul class='list-style-circle'>
  <li>You have the option to provide Beneficiary reference information that will be included within the outgoing payment message. For International payments, 4 beneficiary references lines - 3 lines with a maximum of 34 characters and the 4th with a maximum of 35 characters - may be provided. If you supply any beneficiary reference information, please populate Beneficiary reference line 1 first, followed by Beneficiary reference line 2 etc.</li>
</ul>
</li>
<li>
Ultimate Debtor
<ul class='list-style-circle'>
<li>The section for Ultimate debtor is optional but should be used if the person making the payment is not the debit account owner. If it is used then Name, Address Line 1, Town / City and Country are mandatory fields to be populated. When using an Ultimate Debtor Identifier, please follow the Ultimate debtor instructions detailed previously for IBAN payments.</li>
</ul>
</li>
</ul>


<p>If your beneficiary has asked you to use a format other than IBAN or BBAN then select <strong>OTHER</strong> from the Beneficiary account type drop down. (Note that IBAN or BBAN are standard and recommended ways to send an international payment).&nbsp;</p>
<p>The following fields must be populated to support the successful processing of the payment (screen shots further down in the section).</p>
<ul>
<li>
Beneficiary Details
<ul class='list-style-circle'>
  <li>Beneficiary Name</li>
  <li>Beneficiary Account Type – Select OTHER</li>
  <li>Beneficiary Account Number – Enter Account Number in the format defined by the Beneficiary Bank</li>
  <li>Town/City – Input the town or city of the beneficiary</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Beneficiary Bank Details
<ul class='list-style-circle'>
  <li>Beneficiary Bank SWIFT BIC - 11 character Branch BIC is preferable if known, if not use 8 character Head Office BIC</li>
  <li>Beneficiary Bank Name</li>
  <li>Country – Select Destination Country of Beneficiary Bank</li>
</ul>
</li>
<li>
Payment Details
<ul class='list-style-circle'>
  <li>Execution date is pre-populated but can be changed for a future value dated payment</li>
  <li>Credit or Debit amount must be populated</li>
  <li>Charges will default to Shared but can be amended to Ours or Beneficiary</li>
  <li>Payment purpose code(PPC) is a four-character alphanumeric code which can be added to a payment instruction.  You can look up the correct code by hovering over the info pop up symbol</li>
</ul>
</li>
<li>
Intermediary Bank
<ul class='list-style-circle'>
  <li>This section is optional. You can select your own intermediary bank if you have a preference.&nbsp;</li>
  <li>If it is not completed then LLOYDS BANK use their own network of approved correspondent banks</li>
  <li>If it is used then SWIFT Code is mandatory which then pre-populates all other fields</li>
</ul>
</li>
<li>
Beneficiary Reference
<ul class='list-style-circle'>
  <li>You have the option to provide Beneficiary reference information that will be included within the outgoing payment message. For International payments, 4 beneficiary references lines - 3 lines with a maximum of 34 characters and the 4th with a maximum of 35 characters - may be provided. If you supply any beneficiary reference information, please populate Beneficiary reference line 1 first, followed by Beneficiary reference line 2 etc.</li>
</ul>
</li>
<li>
Ultimate Debtor
<ul class='list-style-circle'>
<li>The section for Ultimate debtor is optional but should be used if the person making the payment is not the debit account owner. If it is used then Name, Address Line 1, Town / City and Country are mandatory fields to be populated. When using an Ultimate Debtor Identifier, please follow the Ultimate debtor instructions detailed previously for IBAN payments.</li>
</ul>
</li>
</ul>

<p>Once you have determined which of the 3 options above is to be used, the payment request can be completed. We have added in below some screen shots and further generic advice to support this activity.</p>
<p>Execution Date field is automatically pre-populated with the date that the payment is being raised. This can be amended for future dated payments.&nbsp;</p>
<p>The execution date is the date LLOYDS BANK begins to make the payment, not necessarily the date the beneficiary receives the funds.&nbsp;</p>
<p>The beneficiary’s bank should pay the beneficiary the same day but this can sometimes take longer based on the currencies involved in the transaction and the country of the beneficiary.&nbsp;</p>
<p>Refer to the cut-off times <strong>in <a href='javascript:void(0)' data-link='appendix3'>Appendix 3</a> </strong>for your currency which will tell you how many days it will take for the beneficiary to receive the funds.&nbsp;</p>
<p>If an international payment has been approved on Execution date (before 6pm) but after the currency cut-off time, Lloyds Bank will  roll the Execution date forwards, rather than reject the payment.</p>
<p>Note that the currency cut off time refers to the credit currency, not the debit currency.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/2.png' /></p>
<p>For cross-currency international payments, an FX rate must be included (if a currency conversion is required), for which there are three possible options:</p>
<ol>
<li>
If you are set up as manual rate FX, unless you have a pre-booked FX rate, you do not enter an FX rate when you make the payment. The payment approver will do that when the payment is approved. At the final approval stage, the approver will need to ‘Get FX Rate’ and approve for the payment to be processed.  
<br/><br/>
<p>Note: the approver does not ‘Get FX Rate’ when they approve the payment if it is future dated.</p>
If the payment is futured dated, the payment FX will be returned to the pending approvals (FX category) on execution date, where the approver has to action the ‘Get FX Rate’. The payment will not be executed until the FX rate is approved (even though the payment was approved previously).
</li>
<li>
You may have a pre-booked FX rate and enter the contract ID and FX rate in the payment initiation screen. This will be approved as part of the payment approval action. It is possible to pre book your FX rate, if you are set up for Manual or Auto Foreign Exchange (Auto FX).
</li>
<li>
You can arrange to be set up for Auto FX - if you choose this option, all payments and transfers (same day or future dated) initiated in GEM Connect, automatically apply the FX rate. This removes the need to manually accept the rate using Get FX Rate. Auto FX will apply to all payments and transfers you make in GEM Connect with a currency exchange and you will not have the option to accept or reject the rate. 
<br/>
If you want to be set up with Auto FX, contact the GEM Servicing team who can arrange this for you.  
</li>
</ol>

<p>Credit or Debit amount can be selected.</p>
<ul>
<li>Selecting debit means you will know how much will be debited from your account but the amount the beneficiary receives will vary depending on the exchange rate.</li>
<li>Selecting credit means the amount the beneficiary receives is known but the amount to be debiting will only be known when the FX rate is fixed.</li>
</ul>
<p>In the example below using Option 1 to ‘Get FX Rate’, it is specified to send a credit of €1,000 and a GBP account has been selected for the debit of funds. The rate provided is 1.1061 which means £904.08 will be debited from the GBP account.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/3.png' /></p>
<p>If you are using a pre-booked FX rate as per Option 2 above then you need to populate the FX Contract ID and FX contract rate fields for approval.</p>
<p>Choose who pays the charge. Possible options are:</p>
<ul>
<li>SHA: the charge is shared between the two parties</li>
<li>OUR: the sender pays the charge</li>
<li>BEN: the beneficiary pays the charge</li>
</ul>
<p>Once you are happy to proceed with payment click on <strong>SUBMIT</strong> and then <strong>DONE</strong> to complete the payment submission</p>
<p><strong>Step 2&nbsp;</strong></p>
<p>This is a display of all the payment information entered and the user has an option to edit data before clicking on submit to proceed to approval.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/4.png' /></p>
<p><strong>Step 3</strong></p>
<p>This shows the user the payment that has been submitted to approval.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/5.png' /></p>
<p>If you want to edit or delete the payment now, you have to find the payment in payment summary.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/6.png' /></p>

<p>In the scenario where a payment with FX, has been approved and has an execution date in the future, the payment can be viewed in payment summary, approved payments, but the FX rate is unknown so will not be displayed. Both the credit and debit amounts will show as the same amounts and currencies. This display will be updated when the FX rate is approved on execution date.</p>
<p>The following table explains when you will see the FX details and when you need to agree to the FX rate (GET FX).</p>
<p>Note: the table applies to customers using manual FX without a pre-booked FX rate. If you have a pre-booked FX rate, you do not need to Get FX rate and the payment will display the FX rate in Payment Summary. If you use Auto FX and the payment is future dated, the FX rate will be displayed on execution date and you do not need to approve the FX rate.</p>
<div class='row'>
<div class='col'>
<p><img src='${process.env.PUBLIC_URL}/images/4/8/9.png'  /></p>
</div>
</div>

<p><u>UETR - Unique end to end transaction reference</u></p>
<p>UETR is a Unique End to End Transaction Reference that is mandatory for SWIFT payments. Lloyds Bank Gem Connect will display the UETR number to on International payments.&nbsp;</p>
<ul>
  <li>It is the SWIFT cross border payments equivalent of a parcel tracking number used for the purposes of track and trace.&nbsp;</li>
  <li>The UETR is generated by the Payer (i.e. Lloyds Bank on the outbound payment) and passed through, without modification, the SWIFT network and any intermediary banks to the Payee (beneficiary).</li>
  <li>UETR is used within the SWIFTgpi Tracker to enable banks and corporates to track the progress of SWIFTgpi payments</li>
  <li>UETR is applicable to inbound and outbound international payments. For outbound payments the UETR will be generated after final approval of an international payment. It is generated in SAP-PE (or IPP as a contingency).</li>
  <li>The UETR format is a total of 36 characters composed of 32 hexadecimal characters, displayed in five groups separated by hyphens: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx&nbsp;</li>
 <ul>
  <li >x = any hexadecimal character (lower case only);&nbsp;</li>
  <li >y is one of 8, 9, a or b.&nbsp;</li>
  <li >It is designed to be globally unique, without risk of repetition over time</li>
  </ul>
</ul>
<p>In Lloyds Bank Gem Connect, the UETR will be displayed to the entitled user on the following pages:</p>
<ol>
  <li><strong>Payment Summary</strong> – Approved payments. UETR will be included in the available fields in the manage columns function so the user can configure it’s display properties on the Approved payment summary page.</li>
  <li><strong>Transaction history</strong> - The UETR is added to the transaction history view. UETR will be included in the available fields in the manage columns function.</li>
  <li><strong>Electronic statements</strong> - The UETR will be included for applicable transactions in electronic statements.</li>
</ol>
<p>For non-related SWIFT payments, the UETR will be a blank field.</p>
<p><u>Payment Summary</u></p>
<p>The UETR is added to the two dialog boxes associated with Payments summary which are accessed via the 3-dot menu in the header column called ‘Manage columns’ and the 3-dot menu associated with the payment item called ‘View’.</p>
<ul>
  <li>The UETR is added to the manage columns dialog available-fields list.</li>
  <li>The UETR is added to the ‘Payment detail’ dialog as the last item in the ‘Payment details’ section.&nbsp;</li>
</ul>
<p><img src='${process.env.PUBLIC_URL}/images/4/9/1.png' /></p>
<p><u>Transaction History</u></p>
<p>The UETR is added to the two dialog boxes associated with ‘Transaction history’ which are accessed via the 3-dot menu in the header column called ‘Manage columns’ and the ‘Details’ link associated with the payment item.</p>

<p>&#8226; &nbsp; The UETR is added to the manage columns dialog available-fields list.</p>
<p>&#8226; &nbsp; The UETR is added to the ‘Transaction details’ dialog as the last item in the ‘Transaction details’ section.&nbsp;</p>

<p><img src='${process.env.PUBLIC_URL}/images/4/9/2.png' /></p>`;


// WEBPACK FOOTER //
// ./src/components/content/payments/10-makeInternationalPymt.ts